import { useEffect, useState } from 'react'
import { Box, Button, MenuItem, Select } from '@mui/material'
import { useIsMobile } from '@/hooks/Responsive'
import '@/styles/policy/index.scss'
import DOMPurify from 'dompurify';

const FILES = [
  {
    label: '현재',
    file: '/policy/terms/terms.html',
  },
  {
    label: '2026년 1월 30일 시행일자 기준',
    file: '/policy/terms/terms-20260130.html',
  },
]

export default function Terms() {
  const { isMobile } = useIsMobile()
  const [selected, setSelected] = useState(FILES[0].file)
  const [safeHtml, setSafeHtml] = useState('')

  const loadHtml = (file) => {
    fetch(file)
      .then((res) => res.text())
      .then((text) => {
        const clean = DOMPurify.sanitize(text, {
          USE_PROFILES: { html: true },
        })

        setSafeHtml(clean)

        // 파일 변경 후 위로 이동
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            window.scrollTo(0, 0)
          })
        })
      })
  }

  // 첫 로딩
  useEffect(() => {
    loadHtml(selected)
  }, [])

  return (
    <Box>
      {/* HTML 렌더링 */}
      <Box dangerouslySetInnerHTML={{ __html: safeHtml }} />

      {/* 선택 영역 - 숨김처리 */}
      {/* <Box sx={{ display: 'flex', gap: 1, mt: 6 }}>
        <Select
          value={selected}
          onChange={(e) => setSelected(e.target.value)}
          sx={{ width: isMobile ? 'auto' : '400px', flex:  isMobile ? 1 : undefined }}
        >
          {FILES.map((item) => (
            <MenuItem key={item.file} value={item.file}>
              {item.label}
            </MenuItem>
          ))}
        </Select>

        <Button
          variant="contained"
          color="grey"
          onClick={() => loadHtml(selected)}
        >
          조회
        </Button>
      </Box> */}
    </Box>
  )
}
